/**
 * Claude model ID constants
 *
 * Single source of truth for all Anthropic model identifiers used across
 * the Pistachiorama stack (API, UI, and Rust DO via copy-paste convention).
 *
 * Update here when Anthropic releases new model versions.
 */
// Claude 4 family — tier pointers (unversioned = latest minor)
export const CLAUDE_SONNET_4 = 'claude-sonnet-4-6';
export const CLAUDE_OPUS_4 = 'claude-opus-4-8'; // repointed from 'claude-opus-4-6' to current latest (#7780)
// Claude 4 per-version IDs (for pricing tables, transcript replay, etc.)
export const CLAUDE_SONNET_4_5 = 'claude-sonnet-4-5';
export const CLAUDE_SONNET_4_BASE = 'claude-sonnet-4'; // bare (no minor); _BASE suffix avoids collision with the tier pointer
export const CLAUDE_OPUS_4_5 = 'claude-opus-4-5';
export const CLAUDE_OPUS_4_6 = 'claude-opus-4-6'; // historical (was the tier pointer before #7780 repoint to 4-8)
export const CLAUDE_OPUS_4_7 = 'claude-opus-4-7';
export const CLAUDE_OPUS_4_8 = 'claude-opus-4-8';
// Claude Haiku (latest)
export const CLAUDE_HAIKU_4_5 = 'claude-haiku-4-5-20251001';
export const CLAUDE_HAIKU_4_5_BARE = 'claude-haiku-4-5'; // bare (no date); _BARE suffix avoids collision with the dated form
export const CLAUDE_HAIKU_3_5 = 'claude-haiku-3-5';
// Claude Fable (above-Opus tier)
export const CLAUDE_FABLE_5 = 'claude-fable-5';
/** Default model for new streams and fallback cases */
export const DEFAULT_CLAUDE_MODEL = CLAUDE_SONNET_4;
//# sourceMappingURL=models.js.map